export default __webpack_public_path__ + "static/media/locationIcon.7928b0ef.svg";